import SingleSelectPage from "@components/SingleSelectPage"

const OPTIONS = [
  { value: "balanced", labelKey: "balancedDiet" },
  { value: "muscle_gain", labelKey: "buildMuscle" },
  { value: "low_carb", labelKey: "loseWeightLowCarb" },
] as const

export default function NutritionGoal() {
  return (
    <SingleSelectPage
      translationKey="nutritionGoal"
      options={OPTIONS}
      subtitleKey="info"
    />
  )
}
